import { DateTime } from "luxon";
import { forwardRef, useState } from "react";
import AccountableWithConfirm from "../../../components/general/AccountableWithConfirm";
import {
  TableContainer,
  Table,
  TRLine,
  DateButton,
  SearchButton,
} from "./styles";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from "date-fns/locale/pt-BR";
import Search from "../../../assets/icons/Search";
import { debounce } from "lodash";
registerLocale("pt-BR", ptBR);

const DateCustomInput = forwardRef(({ value, onClick }, ref) => (
  <DateButton className="example-custom-input" onClick={onClick} ref={ref}>
    {value}
  </DateButton>
));
const DatePickerWithButton = ({ date }) => {
  const [customDate, setCustomDate] = date;

  const dateFormat = "dd/MM/yyyy HH:mm";
  const locale = "pt-BR";

  // Função para formatar a data no formato desejado
  const formatDate = (date) => {
    return DateTime.fromJSDate(date).setLocale(locale).toFormat(dateFormat);
  };

  return (
    <DatePicker
      selected={customDate}
      onChange={(date) => setCustomDate(date)}
      locale={locale}
      showTimeSelect
      timeFormat="HH:mm"
      timeIntervals={15}
      dateFormat={dateFormat}
      // minDate={DateTime.now().plus({ days: 1 }).toJSDate()}
      customInput={<DateCustomInput value={formatDate(customDate)} />}
    />
  );
};

export function HeadTable({ user, start, userList, confirmSearch }) {
  const [openACC, setOpenACC] = useState(false);
  
  const isUserSelected = !!user[0]

  const handleConfirm = debounce(() => {
    if (isUserSelected) 
      confirmSearch();
  }, 300);



  return (
    <TableContainer>
      <Table>
        <thead className="table-head">
          <tr className="first-line">
            <th>Usuário</th>
            <th>Data de Conclusão</th>
            <th>Pesquisar</th>
          </tr>
        </thead>
        <tbody>
          <TRLine>
            <td>
              <AccountableWithConfirm
                style={{ marginLeft: "1rem" }}
                id="confirm-input"
                subtitle=""
                placeholder="+ Selecionar Usuário"
                user={user}
                open={[openACC, setOpenACC]}
                list={userList}
              />
            </td>
            <td>
              <DatePickerWithButton date={start} />
            </td>
            <td>
              <SearchButton
                    style={{ opacity: isUserSelected ? 1 : 0.5 }}
                    onClick={handleConfirm}>
                <Search color="#111" />
              </SearchButton>
            </td>
          </TRLine>
        </tbody>
      </Table>
    </TableContainer>
  );
}
